!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e(require("react"), require("classnames"), require("@material/react-button/dist/index.js"));else if ("function" == typeof define && define.amd) define(["react", "classnames", "@material/react-button/dist/index.js"], e);else {
    var n = "object" == typeof exports ? e(require("react"), require("classnames"), require("@material/react-button/dist/index.js")) : e(t.react, t.classnames, t["@material/react-button/dist/index.js"]);
    for (var o in n) ("object" == typeof exports ? exports : t)[o] = n[o];
  }
}("undefined" != typeof self ? self : this, function (t, e, n) {
  return function (t) {
    var e = {};
    function n(o) {
      if (e[o]) return e[o].exports;
      var r = e[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return t[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }
    return n.m = t, n.c = e, n.d = function (t, e, o) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: o
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var o = Object.create(null);
      if (n.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var r in t) n.d(o, r, function (e) {
        return t[e];
      }.bind(null, r));
      return o;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 60);
  }({
    0: function (e, n) {
      e.exports = t;
    },
    1: function (t, n) {
      t.exports = e;
    },
    161: function (t, e, n) {
      "use strict";

      n.r(e);
      "function" == typeof Symbol && Symbol.iterator;
      /*! *****************************************************************************
      Copyright (c) Microsoft Corporation. All rights reserved.
      Licensed under the Apache License, Version 2.0 (the "License"); you may not use
      this file except in compliance with the License. You may obtain a copy of the
      License at http://www.apache.org/licenses/LICENSE-2.0
      
      THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
      KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
      WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
      MERCHANTABLITY OR NON-INFRINGEMENT.
      
      See the Apache Version 2.0 License for specific language governing permissions
      and limitations under the License.
      ***************************************************************************** */
      var o = function (t, e) {
        return (o = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
        })(t, e);
      };
      var r = function () {
        return (r = Object.assign || function (t) {
          for (var e, n = 1, o = arguments.length; n < o; n++) for (var r in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          return t;
        }).apply(this, arguments);
      };
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var i = function () {
          function t(t) {
            void 0 === t && (t = {}), this.adapter_ = t;
          }
          return Object.defineProperty(t, "cssClasses", {
            get: function () {
              return {};
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t, "strings", {
            get: function () {
              return {};
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t, "numbers", {
            get: function () {
              return {};
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t, "defaultAdapter", {
            get: function () {
              return {};
            },
            enumerable: !0,
            configurable: !0
          }), t.prototype.init = function () {}, t.prototype.destroy = function () {}, t;
        }(),
        a = n(4);
      n.d(e, "MDCDialogFoundation", function () {
        return s;
      });
      /**
       * @license
       * Copyright 2017 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var s = function (t) {
        function e(n) {
          var o = t.call(this, r({}, e.defaultAdapter, n)) || this;
          return o.isOpen_ = !1, o.animationFrame_ = 0, o.animationTimer_ = 0, o.layoutFrame_ = 0, o.escapeKeyAction_ = a.strings.CLOSE_ACTION, o.scrimClickAction_ = a.strings.CLOSE_ACTION, o.autoStackButtons_ = !0, o.areButtonsStacked_ = !1, o;
        }
        return function (t, e) {
          function n() {
            this.constructor = t;
          }
          o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
        }(e, t), Object.defineProperty(e, "cssClasses", {
          get: function () {
            return a.cssClasses;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "strings", {
          get: function () {
            return a.strings;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "numbers", {
          get: function () {
            return a.numbers;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e, "defaultAdapter", {
          get: function () {
            return {
              addBodyClass: function () {},
              addClass: function () {},
              areButtonsStacked: function () {
                return !1;
              },
              clickDefaultButton: function () {},
              eventTargetMatches: function () {
                return !1;
              },
              getActionFromEvent: function () {
                return "";
              },
              hasClass: function () {
                return !1;
              },
              isContentScrollable: function () {
                return !1;
              },
              notifyClosed: function () {},
              notifyClosing: function () {},
              notifyOpened: function () {},
              notifyOpening: function () {},
              releaseFocus: function () {},
              removeBodyClass: function () {},
              removeClass: function () {},
              reverseButtons: function () {},
              trapFocus: function () {}
            };
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.init = function () {
          this.adapter_.hasClass(a.cssClasses.STACKED) && this.setAutoStackButtons(!1);
        }, e.prototype.destroy = function () {
          this.isOpen_ && this.close(a.strings.DESTROY_ACTION), this.animationTimer_ && (clearTimeout(this.animationTimer_), this.handleAnimationTimerEnd_()), this.layoutFrame_ && (cancelAnimationFrame(this.layoutFrame_), this.layoutFrame_ = 0);
        }, e.prototype.open = function () {
          var t = this;
          this.isOpen_ = !0, this.adapter_.notifyOpening(), this.adapter_.addClass(a.cssClasses.OPENING), this.runNextAnimationFrame_(function () {
            t.adapter_.addClass(a.cssClasses.OPEN), t.adapter_.addBodyClass(a.cssClasses.SCROLL_LOCK), t.layout(), t.animationTimer_ = setTimeout(function () {
              t.handleAnimationTimerEnd_(), t.adapter_.trapFocus(), t.adapter_.notifyOpened();
            }, a.numbers.DIALOG_ANIMATION_OPEN_TIME_MS);
          });
        }, e.prototype.close = function (t) {
          var e = this;
          void 0 === t && (t = ""), this.isOpen_ && (this.isOpen_ = !1, this.adapter_.notifyClosing(t), this.adapter_.addClass(a.cssClasses.CLOSING), this.adapter_.removeClass(a.cssClasses.OPEN), this.adapter_.removeBodyClass(a.cssClasses.SCROLL_LOCK), cancelAnimationFrame(this.animationFrame_), this.animationFrame_ = 0, clearTimeout(this.animationTimer_), this.animationTimer_ = setTimeout(function () {
            e.adapter_.releaseFocus(), e.handleAnimationTimerEnd_(), e.adapter_.notifyClosed(t);
          }, a.numbers.DIALOG_ANIMATION_CLOSE_TIME_MS));
        }, e.prototype.isOpen = function () {
          return this.isOpen_;
        }, e.prototype.getEscapeKeyAction = function () {
          return this.escapeKeyAction_;
        }, e.prototype.setEscapeKeyAction = function (t) {
          this.escapeKeyAction_ = t;
        }, e.prototype.getScrimClickAction = function () {
          return this.scrimClickAction_;
        }, e.prototype.setScrimClickAction = function (t) {
          this.scrimClickAction_ = t;
        }, e.prototype.getAutoStackButtons = function () {
          return this.autoStackButtons_;
        }, e.prototype.setAutoStackButtons = function (t) {
          this.autoStackButtons_ = t;
        }, e.prototype.layout = function () {
          var t = this;
          this.layoutFrame_ && cancelAnimationFrame(this.layoutFrame_), this.layoutFrame_ = requestAnimationFrame(function () {
            t.layoutInternal_(), t.layoutFrame_ = 0;
          });
        }, e.prototype.handleInteraction = function (t) {
          var e = "click" === t.type,
            n = "Enter" === t.key || 13 === t.keyCode,
            o = "Space" === t.key || 32 === t.keyCode,
            r = this.adapter_.eventTargetMatches(t.target, a.strings.SCRIM_SELECTOR),
            i = !this.adapter_.eventTargetMatches(t.target, a.strings.SUPPRESS_DEFAULT_PRESS_SELECTOR);
          if (e && r && "" !== this.scrimClickAction_) this.close(this.scrimClickAction_);else if (e || o || n) {
            var s = this.adapter_.getActionFromEvent(t);
            s ? this.close(s) : n && i && this.adapter_.clickDefaultButton();
          }
        }, e.prototype.handleDocumentKeydown = function (t) {
          ("Escape" === t.key || 27 === t.keyCode) && "" !== this.escapeKeyAction_ && this.close(this.escapeKeyAction_);
        }, e.prototype.layoutInternal_ = function () {
          this.autoStackButtons_ && this.detectStackedButtons_(), this.detectScrollableContent_();
        }, e.prototype.handleAnimationTimerEnd_ = function () {
          this.animationTimer_ = 0, this.adapter_.removeClass(a.cssClasses.OPENING), this.adapter_.removeClass(a.cssClasses.CLOSING);
        }, e.prototype.runNextAnimationFrame_ = function (t) {
          var e = this;
          cancelAnimationFrame(this.animationFrame_), this.animationFrame_ = requestAnimationFrame(function () {
            e.animationFrame_ = 0, clearTimeout(e.animationTimer_), e.animationTimer_ = setTimeout(t, 0);
          });
        }, e.prototype.detectStackedButtons_ = function () {
          this.adapter_.removeClass(a.cssClasses.STACKED);
          var t = this.adapter_.areButtonsStacked();
          t && this.adapter_.addClass(a.cssClasses.STACKED), t !== this.areButtonsStacked_ && (this.adapter_.reverseButtons(), this.areButtonsStacked_ = t);
        }, e.prototype.detectScrollableContent_ = function () {
          this.adapter_.removeClass(a.cssClasses.SCROLLABLE), this.adapter_.isContentScrollable() && this.adapter_.addClass(a.cssClasses.SCROLLABLE);
        }, e;
      }(i);
      e.default = s;
    },
    172: function (t, e, n) {
      "use strict";

      n.r(e);
      var o = {};
      /**
       * @license
       * Copyright 2018 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      function r(t, e) {
        if (t.closest) return t.closest(e);
        for (var n = t; n;) {
          if (i(n, e)) return n;
          n = n.parentElement;
        }
        return null;
      }
      function i(t, e) {
        return (t.matches || t.webkitMatchesSelector || t.msMatchesSelector).call(t, e);
      }
      n.r(o), n.d(o, "closest", function () {
        return r;
      }), n.d(o, "matches", function () {
        return i;
      }), n.d(e, "ponyfill", function () {
        return o;
      });
    },
    23: function (t, e, n) {
      "use strict";

      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var o = "mdc-dialog",
        r = {
          BASE: o,
          CONTAINER: o + "__container",
          SURFACE: o + "__surface",
          TITLE: o + "__title",
          CONTENT: o + "__content",
          ACTIONS: o + "__actions",
          BUTTON: o + "__button",
          DEFAULT_BUTTON: o + "__button--default",
          SCRIM: o + "__scrim"
        };
      e.cssClasses = r;
      e.LAYOUT_EVENTS = ["resize", "orientationchange"];
    },
    4: function (t, e, n) {
      "use strict";

      n.r(e), n.d(e, "cssClasses", function () {
        return o;
      }), n.d(e, "strings", function () {
        return r;
      }), n.d(e, "numbers", function () {
        return i;
      });
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      var o = {
          CLOSING: "mdc-dialog--closing",
          OPEN: "mdc-dialog--open",
          OPENING: "mdc-dialog--opening",
          SCROLLABLE: "mdc-dialog--scrollable",
          SCROLL_LOCK: "mdc-dialog-scroll-lock",
          STACKED: "mdc-dialog--stacked"
        },
        r = {
          ACTION_ATTRIBUTE: "data-mdc-dialog-action",
          BUTTON_SELECTOR: ".mdc-dialog__button",
          CLOSED_EVENT: "MDCDialog:closed",
          CLOSE_ACTION: "close",
          CLOSING_EVENT: "MDCDialog:closing",
          CONTAINER_SELECTOR: ".mdc-dialog__container",
          CONTENT_SELECTOR: ".mdc-dialog__content",
          DEFAULT_BUTTON_SELECTOR: ".mdc-dialog__button--default",
          DESTROY_ACTION: "destroy",
          OPENED_EVENT: "MDCDialog:opened",
          OPENING_EVENT: "MDCDialog:opening",
          SCRIM_SELECTOR: ".mdc-dialog__scrim",
          SUPPRESS_DEFAULT_PRESS_SELECTOR: ["textarea", ".mdc-menu .mdc-list-item"].join(", "),
          SURFACE_SELECTOR: ".mdc-dialog__surface"
        },
        i = {
          DIALOG_ANIMATION_CLOSE_TIME_MS: 75,
          DIALOG_ANIMATION_OPEN_TIME_MS: 150
        };
    },
    44: function (t, e, n) {
      var o,
        r,
        i = n(62),
        a = n(63),
        s = (r = [], {
          activateTrap: function (t) {
            if (r.length > 0) {
              var e = r[r.length - 1];
              e !== t && e.pause();
            }
            var n = r.indexOf(t);
            -1 === n ? r.push(t) : (r.splice(n, 1), r.push(t));
          },
          deactivateTrap: function (t) {
            var e = r.indexOf(t);
            -1 !== e && r.splice(e, 1), r.length > 0 && r[r.length - 1].unpause();
          }
        });
      function c(t) {
        return setTimeout(t, 0);
      }
      t.exports = function (t, e) {
        var n = document,
          r = "string" == typeof t ? n.querySelector(t) : t,
          u = a({
            returnFocusOnDeactivate: !0,
            escapeDeactivates: !0
          }, e),
          l = {
            firstTabbableNode: null,
            lastTabbableNode: null,
            nodeFocusedBeforeActivation: null,
            mostRecentlyFocusedNode: null,
            active: !1,
            paused: !1
          },
          f = {
            activate: function (t) {
              if (!l.active) {
                g(), l.active = !0, l.paused = !1, l.nodeFocusedBeforeActivation = n.activeElement;
                var e = t && t.onActivate ? t.onActivate : u.onActivate;
                return e && e(), p(), f;
              }
            },
            deactivate: d,
            pause: function () {
              !l.paused && l.active && (l.paused = !0, m());
            },
            unpause: function () {
              l.paused && l.active && (l.paused = !1, g(), p());
            }
          };
        return f;
        function d(t) {
          if (l.active) {
            clearTimeout(o), m(), l.active = !1, l.paused = !1, s.deactivateTrap(f);
            var e = t && void 0 !== t.onDeactivate ? t.onDeactivate : u.onDeactivate;
            return e && e(), (t && void 0 !== t.returnFocus ? t.returnFocus : u.returnFocusOnDeactivate) && c(function () {
              C(l.nodeFocusedBeforeActivation);
            }), f;
          }
        }
        function p() {
          if (l.active) return s.activateTrap(f), o = c(function () {
            C(h());
          }), n.addEventListener("focusin", v, !0), n.addEventListener("mousedown", _, {
            capture: !0,
            passive: !1
          }), n.addEventListener("touchstart", _, {
            capture: !0,
            passive: !1
          }), n.addEventListener("click", b, {
            capture: !0,
            passive: !1
          }), n.addEventListener("keydown", O, {
            capture: !0,
            passive: !1
          }), f;
        }
        function m() {
          if (l.active) return n.removeEventListener("focusin", v, !0), n.removeEventListener("mousedown", _, !0), n.removeEventListener("touchstart", _, !0), n.removeEventListener("click", b, !0), n.removeEventListener("keydown", O, !0), f;
        }
        function y(t) {
          var e = u[t],
            o = e;
          if (!e) return null;
          if ("string" == typeof e && !(o = n.querySelector(e))) throw new Error("`" + t + "` refers to no known node");
          if ("function" == typeof e && !(o = e())) throw new Error("`" + t + "` did not return a node");
          return o;
        }
        function h() {
          var t;
          if (!(t = null !== y("initialFocus") ? y("initialFocus") : r.contains(n.activeElement) ? n.activeElement : l.firstTabbableNode || y("fallbackFocus"))) throw new Error("You can't have a focus-trap without at least one focusable element");
          return t;
        }
        function _(t) {
          r.contains(t.target) || (u.clickOutsideDeactivates ? d({
            returnFocus: !i.isFocusable(t.target)
          }) : t.preventDefault());
        }
        function v(t) {
          r.contains(t.target) || t.target instanceof Document || (t.stopImmediatePropagation(), C(l.mostRecentlyFocusedNode || h()));
        }
        function O(t) {
          if (!1 !== u.escapeDeactivates && function (t) {
            return "Escape" === t.key || "Esc" === t.key || 27 === t.keyCode;
          }(t)) return t.preventDefault(), void d();
          (function (t) {
            return "Tab" === t.key || 9 === t.keyCode;
          })(t) && function (t) {
            if (g(), t.shiftKey && t.target === l.firstTabbableNode) return t.preventDefault(), void C(l.lastTabbableNode);
            t.shiftKey || t.target !== l.lastTabbableNode || (t.preventDefault(), C(l.firstTabbableNode));
          }(t);
        }
        function b(t) {
          u.clickOutsideDeactivates || r.contains(t.target) || (t.preventDefault(), t.stopImmediatePropagation());
        }
        function g() {
          var t = i(r);
          l.firstTabbableNode = t[0] || h(), l.lastTabbableNode = t[t.length - 1] || h();
        }
        function C(t) {
          t !== n.activeElement && (t && t.focus ? (t.focus(), l.mostRecentlyFocusedNode = t, function (t) {
            return t.tagName && "input" === t.tagName.toLowerCase() && "function" == typeof t.select;
          }(t) && t.select()) : C(h()));
        }
      };
    },
    60: function (t, e, n) {
      "use strict";

      var o,
        r = this && this.__extends || (o = function (t, e) {
          return (o = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (t, e) {
            t.__proto__ = e;
          } || function (t, e) {
            for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n]);
          })(t, e);
        }, function (t, e) {
          function n() {
            this.constructor = t;
          }
          o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n());
        }),
        i = this && this.__assign || function () {
          return (i = Object.assign || function (t) {
            for (var e, n = 1, o = arguments.length; n < o; n++) for (var r in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t;
          }).apply(this, arguments);
        },
        a = this && this.__rest || function (t, e) {
          var n = {};
          for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var r = 0;
            for (o = Object.getOwnPropertySymbols(t); r < o.length; r++) e.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[r]) && (n[o[r]] = t[o[r]]);
          }
          return n;
        },
        s = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var c = s(n(0)),
        u = s(n(1)),
        l = n(161),
        f = n(61),
        d = n(4),
        p = n(172),
        m = s(n(64));
      e.DialogContent = m.default;
      var y = s(n(65));
      e.DialogFooter = y.default;
      var h = s(n(66));
      e.DialogTitle = h.default;
      var _ = s(n(67));
      e.DialogButton = _.default;
      var v = n(23);
      function O(t) {
        return t.type === h.default;
      }
      var b = function (t) {
        function e() {
          var e = null !== t && t.apply(this, arguments) || this;
          return e.dialogElement = c.default.createRef(), e.state = {
            classList: new Set()
          }, e.open = function () {
            e.initializeFocusTrap(), e.foundation.open();
          }, e.initializeFocusTrap = function () {
            e.focusTrap = e.props.children && f.createFocusTrapInstance(e.dialogElement.current);
          }, e.handleOpening = function () {
            e.props.onOpening(), v.LAYOUT_EVENTS.forEach(function (t) {
              return window.addEventListener(t, e.handleLayout);
            }), document.addEventListener("keydown", e.handleDocumentKeyDown);
          }, e.handleClosing = function (t) {
            e.props.onClosing(t), v.LAYOUT_EVENTS.forEach(function (t) {
              return window.removeEventListener(t, e.handleLayout);
            }), document.removeEventListener("keydown", e.handleDocumentKeyDown);
          }, e.handleInteraction = function (t) {
            return e.foundation.handleInteraction(t.nativeEvent);
          }, e.handleDocumentKeyDown = function (t) {
            return e.foundation.handleDocumentKeydown(t);
          }, e.handleLayout = function () {
            return e.foundation.layout();
          }, e.renderContainer = function (t) {
            return t ? c.default.createElement("div", {
              className: v.cssClasses.CONTAINER
            }, c.default.createElement("div", {
              className: v.cssClasses.SURFACE
            }, c.default.Children.map(t, e.renderChild))) : void 0;
          }, e.renderChild = function (t, n) {
            return O(t) || t.type === m.default ? c.default.cloneElement(t, i({
              key: "child-" + n
            }, t.props, {
              id: e.setId(t, t.props.id)
            })) : t;
          }, e.setId = function (t, n) {
            var o = e.props.id;
            if (O(t)) {
              var r = n || o + "-title";
              return e.labelledBy = r, r;
            }
            var i = n || o + "-content";
            return e.describedBy = i, i;
          }, e;
        }
        return r(e, t), e.prototype.componentDidMount = function () {
          var t = this.props,
            e = t.open,
            n = t.autoStackButtons,
            o = t.escapeKeyAction,
            r = t.scrimClickAction;
          this.foundation = new l.MDCDialogFoundation(this.adapter), this.foundation.init(), e && this.open(), n || this.foundation.setAutoStackButtons(n), "string" == typeof o && this.foundation.setEscapeKeyAction(o), "string" == typeof r && this.foundation.setScrimClickAction(r);
        }, e.prototype.componentWillUnmount = function () {
          this.foundation.destroy();
        }, e.prototype.componentDidUpdate = function (t) {
          var e = this.props,
            n = e.open,
            o = e.autoStackButtons,
            r = e.escapeKeyAction,
            i = e.scrimClickAction;
          if (t.autoStackButtons !== o && this.foundation.setAutoStackButtons(o), t.escapeKeyAction !== r && this.foundation.setEscapeKeyAction(r), t.scrimClickAction !== i && this.foundation.setScrimClickAction(i), t.open !== n) return n ? this.open() : this.foundation.close();
        }, Object.defineProperty(e.prototype, "classes", {
          get: function () {
            var t = this.state.classList,
              e = this.props.className;
            return u.default(v.cssClasses.BASE, Array.from(t), e);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "buttons", {
          get: function () {
            var t = this.dialogElement.current && [].slice.call(this.dialogElement.current.getElementsByClassName(v.cssClasses.BUTTON));
            return t || [];
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "content", {
          get: function () {
            return this.dialogElement.current && this.dialogElement.current.querySelector("." + v.cssClasses.CONTENT);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "defaultButton", {
          get: function () {
            return this.dialogElement.current && this.dialogElement.current.querySelector("." + v.cssClasses.DEFAULT_BUTTON);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(e.prototype, "adapter", {
          get: function () {
            var t = this,
              e = l.MDCDialogFoundation.strings,
              n = p.ponyfill.closest,
              o = p.ponyfill.matches;
            return {
              addClass: function (e) {
                var n = t.state.classList;
                n.add(e), t.setState({
                  classList: n
                });
              },
              removeClass: function (e) {
                var n = t.state.classList;
                n.delete(e), t.setState({
                  classList: n
                });
              },
              hasClass: function (e) {
                return t.classes.split(" ").includes(e);
              },
              addBodyClass: function (t) {
                return document.body.classList.add(t);
              },
              removeBodyClass: function (t) {
                return document.body.classList.remove(t);
              },
              eventTargetMatches: function (t, e) {
                return o(t, e);
              },
              trapFocus: function () {
                return t.focusTrap && t.focusTrap.activate();
              },
              releaseFocus: function () {
                return t.focusTrap && t.focusTrap.deactivate();
              },
              isContentScrollable: function () {
                var e = t.content;
                return !!e && f.isScrollable(e);
              },
              areButtonsStacked: function () {
                return !!t.buttons && f.areTopsMisaligned(t.buttons);
              },
              getActionFromEvent: function (t) {
                var o = n(t.target, "[" + e.ACTION_ATTRIBUTE + "]");
                return o && o.getAttribute(e.ACTION_ATTRIBUTE);
              },
              clickDefaultButton: function () {
                var e = t.defaultButton;
                e && e.click();
              },
              reverseButtons: function () {
                var e = t.buttons;
                return e && e.reverse().forEach(function (t) {
                  return t.parentElement && t.parentElement.appendChild(t);
                });
              },
              notifyOpening: function () {
                return t.handleOpening();
              },
              notifyOpened: function () {
                return t.props.onOpen && t.props.onOpen();
              },
              notifyClosing: function (e) {
                return t.handleClosing(e);
              },
              notifyClosed: function (e) {
                return t.props.onClose && t.props.onClose(e);
              }
            };
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype.render = function () {
          var t = this.props,
            e = (t.autoStackButtons, t.className, t.children),
            n = (t.escapeKeyAction, t.id),
            o = (t.onOpening, t.onOpen, t.onClick, t.onClosing, t.onClose, t.onKeyDown, t.open, t.scrimClickAction, t.tag),
            r = a(t, ["autoStackButtons", "className", "children", "escapeKeyAction", "id", "onOpening", "onOpen", "onClick", "onClosing", "onClose", "onKeyDown", "open", "scrimClickAction", "tag"]),
            s = this.renderContainer(e);
          return c.default.createElement(o, i({}, r, {
            "aria-labelledby": this.labelledBy,
            "aria-describedby": this.describedBy,
            "aria-modal": !0,
            className: this.classes,
            id: n,
            onKeyDown: this.handleInteraction,
            onClick: this.handleInteraction,
            ref: this.dialogElement
          }), s, c.default.createElement("div", {
            className: v.cssClasses.SCRIM
          }));
        }, e.defaultProps = {
          autoStackButtons: !0,
          className: "",
          onOpening: function () {},
          onClosing: function () {},
          tag: "div",
          id: "mdc-dialog",
          open: !1,
          role: "alertdialog",
          escapeKeyAction: d.strings.CLOSE_ACTION,
          scrimClickAction: d.strings.CLOSE_ACTION
        }, e;
      }(c.default.Component);
      e.default = b;
    },
    61: function (t, e, n) {
      "use strict";

      n.r(e), n.d(e, "createFocusTrapInstance", function () {
        return i;
      }), n.d(e, "isScrollable", function () {
        return a;
      }), n.d(e, "areTopsMisaligned", function () {
        return s;
      });
      var o = n(44),
        r = n.n(o);
      /**
       * @license
       * Copyright 2016 Google Inc.
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in
       * all copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
       * THE SOFTWARE.
       */
      function i(t, e, n) {
        return void 0 === e && (e = r.a), e(t, {
          clickOutsideDeactivates: !0,
          escapeDeactivates: !1,
          initialFocus: n
        });
      }
      function a(t) {
        return !!t && t.scrollHeight > t.offsetHeight;
      }
      function s(t) {
        var e = new Set();
        return [].forEach.call(t, function (t) {
          return e.add(t.offsetTop);
        }), e.size > 1;
      }
    },
    62: function (t, e) {
      var n = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'],
        o = n.join(","),
        r = "undefined" == typeof Element ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
      function i(t, e) {
        e = e || {};
        var n,
          i,
          s,
          c = [],
          f = [],
          d = t.querySelectorAll(o);
        for (e.includeContainer && r.call(t, o) && (d = Array.prototype.slice.apply(d)).unshift(t), n = 0; n < d.length; n++) a(i = d[n]) && (0 === (s = u(i)) ? c.push(i) : f.push({
          documentOrder: n,
          tabIndex: s,
          node: i
        }));
        return f.sort(l).map(function (t) {
          return t.node;
        }).concat(c);
      }
      function a(t) {
        return !(!s(t) || function (t) {
          return function (t) {
            return f(t) && "radio" === t.type;
          }(t) && !function (t) {
            if (!t.name) return !0;
            var e = function (t) {
              for (var e = 0; e < t.length; e++) if (t[e].checked) return t[e];
            }(t.ownerDocument.querySelectorAll('input[type="radio"][name="' + t.name + '"]'));
            return !e || e === t;
          }(t);
        }(t) || u(t) < 0);
      }
      function s(t) {
        return !(t.disabled || function (t) {
          return f(t) && "hidden" === t.type;
        }(t) || function (t) {
          return null === t.offsetParent || "hidden" === getComputedStyle(t).visibility;
        }(t));
      }
      i.isTabbable = function (t) {
        if (!t) throw new Error("No node provided");
        return !1 !== r.call(t, o) && a(t);
      }, i.isFocusable = function (t) {
        if (!t) throw new Error("No node provided");
        return !1 !== r.call(t, c) && s(t);
      };
      var c = n.concat("iframe").join(",");
      function u(t) {
        var e = parseInt(t.getAttribute("tabindex"), 10);
        return isNaN(e) ? function (t) {
          return "true" === t.contentEditable;
        }(t) ? 0 : t.tabIndex : e;
      }
      function l(t, e) {
        return t.tabIndex === e.tabIndex ? t.documentOrder - e.documentOrder : t.tabIndex - e.tabIndex;
      }
      function f(t) {
        return "INPUT" === t.tagName;
      }
      t.exports = i;
    },
    63: function (t, e) {
      t.exports = function () {
        for (var t = {}, e = 0; e < arguments.length; e++) {
          var o = arguments[e];
          for (var r in o) n.call(o, r) && (t[r] = o[r]);
        }
        return t;
      };
      var n = Object.prototype.hasOwnProperty;
    },
    64: function (t, e, n) {
      "use strict";

      var o = this && this.__assign || function () {
          return (o = Object.assign || function (t) {
            for (var e, n = 1, o = arguments.length; n < o; n++) for (var r in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t;
          }).apply(this, arguments);
        },
        r = this && this.__rest || function (t, e) {
          var n = {};
          for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var r = 0;
            for (o = Object.getOwnPropertySymbols(t); r < o.length; r++) e.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[r]) && (n[o[r]] = t[o[r]]);
          }
          return n;
        },
        i = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var a = i(n(0)),
        s = i(n(1)),
        c = n(23);
      e.default = function (t) {
        var e = t.className,
          n = void 0 === e ? "" : e,
          i = t.children,
          u = t.tag,
          l = void 0 === u ? "div" : u,
          f = r(t, ["className", "children", "tag"]);
        return a.default.createElement(l, o({
          className: s.default(n, c.cssClasses.CONTENT)
        }, f), i);
      };
    },
    65: function (t, e, n) {
      "use strict";

      var o = this && this.__assign || function () {
          return (o = Object.assign || function (t) {
            for (var e, n = 1, o = arguments.length; n < o; n++) for (var r in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t;
          }).apply(this, arguments);
        },
        r = this && this.__rest || function (t, e) {
          var n = {};
          for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var r = 0;
            for (o = Object.getOwnPropertySymbols(t); r < o.length; r++) e.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[r]) && (n[o[r]] = t[o[r]]);
          }
          return n;
        },
        i = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var a = i(n(0)),
        s = i(n(1)),
        c = n(23);
      e.default = function (t) {
        var e = t.className,
          n = void 0 === e ? "" : e,
          i = t.children,
          u = t.tag,
          l = void 0 === u ? "footer" : u,
          f = r(t, ["className", "children", "tag"]);
        return a.default.createElement(l, o({
          className: s.default(n, c.cssClasses.ACTIONS)
        }, f), i);
      };
    },
    66: function (t, e, n) {
      "use strict";

      var o = this && this.__assign || function () {
          return (o = Object.assign || function (t) {
            for (var e, n = 1, o = arguments.length; n < o; n++) for (var r in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t;
          }).apply(this, arguments);
        },
        r = this && this.__rest || function (t, e) {
          var n = {};
          for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var r = 0;
            for (o = Object.getOwnPropertySymbols(t); r < o.length; r++) e.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[r]) && (n[o[r]] = t[o[r]]);
          }
          return n;
        },
        i = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var a = i(n(0)),
        s = i(n(1)),
        c = n(23);
      e.default = function (t) {
        var e = t.className,
          n = void 0 === e ? "" : e,
          i = t.children,
          u = t.tag,
          l = void 0 === u ? "h2" : u,
          f = r(t, ["className", "children", "tag"]);
        return a.default.createElement(l, o({
          className: s.default(n, c.cssClasses.TITLE)
        }, f), i);
      };
    },
    67: function (t, e, n) {
      "use strict";

      var o = this && this.__assign || function () {
          return (o = Object.assign || function (t) {
            for (var e, n = 1, o = arguments.length; n < o; n++) for (var r in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
            return t;
          }).apply(this, arguments);
        },
        r = this && this.__rest || function (t, e) {
          var n = {};
          for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && e.indexOf(o) < 0 && (n[o] = t[o]);
          if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
            var r = 0;
            for (o = Object.getOwnPropertySymbols(t); r < o.length; r++) e.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[r]) && (n[o[r]] = t[o[r]]);
          }
          return n;
        },
        i = this && this.__importDefault || function (t) {
          return t && t.__esModule ? t : {
            default: t
          };
        };
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var a = i(n(0)),
        s = i(n(1)),
        c = n(23),
        u = i(n(68));
      e.default = function (t) {
        var e,
          n = t.action,
          i = t.className,
          l = void 0 === i ? "" : i,
          f = t.children,
          d = t.isDefault,
          p = void 0 !== d && d,
          m = r(t, ["action", "className", "children", "isDefault"]);
        return a.default.createElement(u.default, o({
          className: s.default(l, c.cssClasses.BUTTON, (e = {}, e[c.cssClasses.DEFAULT_BUTTON] = p, e)),
          "data-mdc-dialog-action": n
        }, m), f);
      };
    },
    68: function (t, e) {
      t.exports = n;
    }
  });
});